import styled from 'styled-components';

export const LogoContainer = styled.div`
    display: flex;
`;

export const LogoDescription = styled.span`
    margin: ${({ theme }) => theme.space[4]};
    color: ${({ theme }) => theme.color.grey[40]};
    font-size: ${({ theme }) => theme.fontSize.xlg};
`;

export const LogoImage = styled.img``;
